/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ValidationType } from "./ValidationType";
import { ValidationSource } from "./ValidationSource";
import { JsonPathString } from "../../commons/types/JsonPathString";
export const ValidationMessage = core.serialization.object({
    field: core.serialization.string().optional(),
    type: ValidationType.optional(),
    source: ValidationSource.optional(),
    message: core.serialization.string().optional(),
    path: JsonPathString.optional(),
});
